<template>
<v-container fluid>
	<v-layout align-center justify-center>
		<v-flex xs12 sm8 md6>
			<v-card flat class="elevation-2 mt-4">
				<v-toolbar flat dark :class="indicator.class">
					<v-toolbar-title>{{ indicator.message }}</v-toolbar-title>
				</v-toolbar>
				<v-card-text>
					<v-form @submit.prevent="onVerify">
						<v-text-field
							prepend-icon="lock" name="code"
							label="Проверочный код" id="code"
							type="password" v-model="code"  required>
						</v-text-field>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn type="submit" :color="indicator.class">Войти</v-btn>
						</v-card-actions>
					</v-form>
				</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</v-container>
</template>

<script>
import { SIGN } from '@/utils'
import { AuthChecker as isAuth } from '@/utils'
import store from '@/store'

export default {
	data() {
		return {
            phone: store.phone,
            code: '',
			indicator: {
				class: 'primary',
				message: 'Авторизация'
			}
		}
	},
	computed: {},
	methods: {
		onVerify() {
			this.$store.dispatch('VERIFY_REQUEST', {
				phone: this.phone,
				code: this.code
			})
			.then( () => {
				this.$router.push('/')
			})
			.catch(err => {
				throw err
			})
		},

		checkForm(value) { //TODO write checkPhone, checkPassword
			return []
		}

	},

	created() {
		if( isAuth() ) {
			this.$router.push('/')
		}
	}

}
</script>